/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import { Tr } from '../../../_metronic/i18n/Tr'
import { eLevel, encryptData, getEncryptedRoute } from '../../../reusable'

interface AccountHeaderProps {
  menuId: string
}
const AccountHeader: React.FC<AccountHeaderProps> = ({ menuId }) => {
  let t = Tr()
  const location = useLocation()  
  // view profile api call

  useEffect(()=>{
    document.title = 'Insayr | Vendors'     
  },[])
  
  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/viewvendor/all' && 'active')
                }
                to={getEncryptedRoute("../all" , {menuId :menuId})}
              >
                {t("All")}
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/viewvendor/active' && 'active')
                }
                to={getEncryptedRoute("../active" , {menuId :menuId})}
              >
                 {t("Active")}
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/viewvendor/inactive' && 'active')
                }
                to={getEncryptedRoute("../inactive" , {menuId :menuId})}
              > 
                  {t("Inactive")}
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/viewvendor/verified' && 'active')
                }
                to={getEncryptedRoute("../verified" , {menuId :menuId})}
              >
                  {t("Verified")}
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/viewvendor/pending' && 'active')
                }
                to={getEncryptedRoute("../pending" , {menuId :menuId})}
              >
                   {t("Pending")}
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/viewvendor/rejected' && 'active')
                }
                to={getEncryptedRoute("../rejected" , {menuId :menuId})}
              >
                
                  {t("Rejected")}
              </Link>
            </li>
            
          </ul>
        </div>
      </div>
    </div>
  )
}

export {AccountHeader}
